import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { LLMTemplatesState, SLICE_NAME } from './models';

const llmTemplatesSelector = (state: RootState): LLMTemplatesState => state[SLICE_NAME];

export const selectLLMTemplates = createSelector(llmTemplatesSelector, (state: LLMTemplatesState) => state.templates);

export const selectLLMTemplatesIsLoading = createSelector(
  llmTemplatesSelector,
  (state: LLMTemplatesState) => state.isLoading,
);

export const selectLLMTemplatesError = createSelector(llmTemplatesSelector, (state: LLMTemplatesState) => state.error);
